
/// Require

var ModalActionButton = require('./modal-action-button');
var BaseModal = require('./base-modal');


/// Config

var successClass = 'positive';
var failureClass = 'negative';


//
// Campaign Deletion Modal
//

module.exports = function CampaignDeleteModal ($host, config) {

  var base = BaseModal($host, config);


  // Dom

  var $inputConfirm = $('[name="confirmation"]', $host);


  // Widgets

  var actionButton = getWidgetAtDom($('[data-action="delete"]', $host));


  /// State

  var state = {
    confirmed: false
  };


  /// Functions

  function populate (data) {

    if (!isdef(data.campaign_id)) console.warn("DeleteCampaignModal::populate - expected key 'campaign_id' but didn't find it.");

    // Reset input and output values
    $inputConfirm.val(null);

    // Reset state
    state.confirmed   = false;
    state.campaign_id = data.campaign_id;

    // Clear visual state
    $host.removeClass(successClass);
    actionButton.setMode(ModalActionButton.ACTION_NEUTRAL);

    // Wait slightly for modal to be visible, then focus first input
    delay(0.2, $inputConfirm.focus.bind($inputConfirm));
  }

  function checkCompleteness () {
    state.confirmed = $inputConfirm.val().toLowerCase() === 'delete';
    actionButton.setMode(state.confirmed ? ModalActionButton.ACTION_READY : ModalActionButton.ACTION_NEUTRAL);
  }


  /// Listeners

  $inputConfirm.on('change keyup', checkCompleteness);

  actionButton.onCancelClick(base.conceal);

  actionButton.onReadyClick(function () {
    actionButton.submit({
      campaign_id: state.campaign_id
    });
  });

  actionButton.onSuccess(function () {
    $host.addClass(successClass);
    delay(1, base.conceal);
    delay(1.1, window.location = config.redirectUrl);
  });


  /// Interface

  return {
    invoke: function (data) {
      log('invoke:', data);
      base.reveal();
      populate(data);
    }
  }

};

